(async function () {
  const cart_items_els = [...document.querySelectorAll("[insert-cart-lines]")];
  const cart_item_count_els = [
    ...document.querySelectorAll("[data-cart-item-count]"),
  ];
  const cart_pricing_els = [
    ...document.querySelectorAll("[data-cart-pricing]"),
  ];

  window.updateCartUI = async function () {
    let items_ui = await fetch(
      `${window.Shopify.routes.root}?section_id=cart-items`
    );
    items_ui = await items_ui.text();
    const html = new DOMParser().parseFromString(items_ui, "text/html");
    const cart_items_html = html.querySelector(
      "#shopify-section-cart-items"
    ).innerHTML;
    const cart_json = JSON.parse(html.querySelector("#cart-data").innerText);

    const cart_content_el = document.querySelector(".CartDrawerContent");
    if (cart_json.item_count === 0) {
      cart_content_el.classList.add("is-empty");
    } else {
      cart_content_el.classList.remove("is-empty");
    }

    cart_items_els.forEach(function (el) {
      el.innerHTML = cart_items_html;
    });
    cart_item_count_els.forEach(function (el) {
      el.innerHTML = cart_json.item_count;
    });

    cart_pricing_els.forEach(function (el) {
      el.setAttribute("price", cart_json.price);
    });
  };

  const Layer = await waitForLayer();
  const syncCart = Layer.api.cart.sync.bind();
  const addItem = Layer.api.cart.addItem.bind();
  const changeItem = Layer.api.cart.changeItem.bind();
  const update = Layer.api.cart.update.bind();

  const { toDebouncedFn } = Layer.libs["@useful/helpers"];

  Layer.api.cart.sync = async function () {
    await syncCart();
    window.updateCartUI();
  };
  Layer.api.cart.addItem = async function (...args) {
    await addItem(...args);
    Layer.api.cart.sync();
    cart_drawer.open();
  };
  Layer.api.cart.changeItem = async function (...args) {
    await changeItem(...args);
    await Layer.api.cart.sync();
  };
  Layer.api.cart.update = async function (...args) {
    await update(...args);
    //
  };
  Layer.api.cart.addOrderNote = toDebouncedFn(async function (note) {
    await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ note }),
    });
    //await Layer.api.cart.sync();
  }, 400);
  Layer.api.cart.addHandWrittenNote = toDebouncedFn(async function (note) {
    await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          "Handwritten Note": note,
        },
      }),
    });
    //await Layer.api.cart.sync();
  }, 400);

  Layer.api.cart.sync();



  function isTextOverflowing(element) {
    return element.scrollWidth > element.clientWidth;
  }

  function handleProductCardsOverflowHover() {
    [...document.querySelectorAll(".ProductCard h2 span")].forEach(function(el) {
      let card = el.closest(".ProductCard");
      if (isTextOverflowing(el)) {
        card.classList.add("do-hover-effect")
      } else {
        card.classList.remove("do-hover-effect")
      }
    })
  }
  handleProductCardsOverflowHover();
  window.addEventListener("resize", handleProductCardsOverflowHover)
})();
